import { createSelector } from '@reduxjs/toolkit';
import menusSelector from './menus';

const selectedSubMenuItemSelector = createSelector(menusSelector, (menus) => menus.selectedSubmenuItem);

export default selectedSubMenuItemSelector;
